<template>
  <div>
      	<a-modal v-model="tenderView" title="投标申请" width="60%"  @cancel="closeView">
			<template slot="footer">
				<a-button key="submit" type="primary" @click="tenderOk"> 提交 </a-button>
				<a-button key="back" @click="closeView"> 取消 </a-button>
			</template>
			<a-form-model :model="tenderForm" ref="tenderRef" :label-col="labelCol3" :wrapper-col="wrapperCol3">
                 
                <a-form-model-item label="选择抄送人" :label-col="labelCol2" :wrapper-col="wrapperCol2">
                    <ccChange :data="ccC" @targetKeys="currencygetdata" v-if="tenderView" />
                </a-form-model-item>
				<a-row>
                    <a-col :span="8">
						<a-form-model-item label="业务员" prop="salesman" :rules="{
							required: true,
							message: '请输入业务员',
							trigger: 'change',
						}">
							<a-input v-model="tenderForm.salesman" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属公司" prop="companyId" :rules="{
							required: true,
							message: '请输入业务员',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="隶属公司" v-model="tenderForm.companyId"
								@change="handlecompanyplan">
								<a-select-option :value="item.deptId" v-for="(item, index) in companylist"
									:key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					<a-col :span="8">
						<a-form-model-item label="隶属部门" prop="subjectionDeptId" :rules="{
							required: true,
							message: '请输入业务员',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="隶属部门" :disabled="!tenderForm.companyId"
								v-model="tenderForm.subjectionDeptId" @change="changeDept">
								<a-select-option :value="item.deptId" v-for="(item, index) in deptlist" :key="index">
									{{ item.title }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
					<a-col :span="8">
						<a-form-model-item label="投标截止日期" prop="deadline" :rules="{
							required: true,
							message: '请选择日期',
							trigger: 'change',
						}">
							<a-date-picker valueFormat="YYYY-MM-DD" style="width: 100%" :value="tenderForm.deadline"
								@change="stampDateChange" />
						</a-form-model-item>
					</a-col>
					 <a-col :span="8">
						<a-form-model-item label="标书费用" prop="bidFee">
							<a-input v-model="tenderForm.bidFee" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="保证金" prop="deposit">
							<a-input v-model="tenderForm.deposit" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
                </a-row>
				<a-row>
                    <a-col :span="8">
						<a-form-model-item label="是否寄送" prop="send" :rules="{
							required: true,
							message: '请输选择是否寄送',
							trigger: 'change',
						}">
							<a-select allowClear placeholder="请选择是否寄送" v-model="tenderForm.send" @change="changeDept">
								<a-select-option value="1">是</a-select-option>
								<a-select-option value="0">否</a-select-option>
							</a-select>
						</a-form-model-item>
					</a-col>
					 <a-col :span="8">
						<a-form-model-item label="项目名称" prop="projectName" :rules="{
							required: true,
							message: '请输入项目名称',
							trigger: 'change',
						}">
							<a-input v-model="tenderForm.projectName" placeholder="请输入"></a-input>
						</a-form-model-item>
					</a-col>
                    <a-col :span="8">
						<a-form-model-item label="申请原因" prop="reason" :rules="{
							required: true,
							message: '请输入申请原因',
							trigger: 'change',
						}">
						    <a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="tenderForm.reason" allowClear placeholder="请输入" ></a-textarea>
						</a-form-model-item>
					</a-col>
				</a-row>
				<a-row>
                    <!-- <a-col :span="8">
						<a-form-model-item label="附件(必填)" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
							<uploadFileCode :data="uploadData" v-if="tenderForm" @getList="getList" type="1"/>
						</a-form-model-item>
					</a-col> -->
					<!-- <a-col :span="8"> -->
                        <!-- <a-form-model-item label="图片上传:" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }"> -->
							<span><span style="color:red;margin-right:5px;mrgin-bottom:5px;">*</span>图片:</span>
							<uploadImgJava  v-if="tenderForm" ref="uploadImgJava" :data="billDataImg" @getList="getList"/>
						<!-- </a-form-model-item> -->
                    <!-- </a-col> -->
                </a-row>
			</a-form-model>
		</a-modal>
  </div>
</template>

<script>
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import ccChange from '@/components/module/ccChange'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import { projectAmountApply, bidSave,salaryCode ,bidCode} from '@/api/budget'
import { tree_all } from '@/api/purchase'
export default {
    components: {
        ccChange,
        uploadFileCode,
		uploadImgJava
    },
    data() {
        return {
			billDataImg: {
                code: '',
                type: 'bid-appendix',
            },
            labelCol2: {
				span: 2
			},
			wrapperCol2: {
				span: 22
			},
            tenderView: false,
            cc:'',
            ccC: '',
            labelCol3: {
                span: 8
            },
            wrapperCol3:{
                span: 16
            } ,
            tenderForm: {
                salesman: '',
                companyId: undefined,//公司id
                // deptId: '',
                subjectionDeptId: undefined,//部门id
                deadline: '',
                bidFee: 0,
                deposit: 0,
                send: undefined,
                reason: '',
				projectName: '',

            },
            deptlist: [],
            companylist: [],
            code: '',
            uploadData: {
                code: '',
				type: 'bid-appendix',
            },
            fileList: [],

            }
    },
    methods: {
        show() {
            this.tenderView = true
            this.getCompany()
            //  this.ccC = 'pr-amount'
            // 获取项目申请编号
            bidCode().then(res => {
                if(res.code == 200) {
                    this.code = res.data
                    this.uploadData.code = res.data
					this.billDataImg.code = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        getCompany() {
			tree_all().then((res) => {
				if (res.code == 200) {
					this.companylist = res.data[0]
					// this.companylist.forEach((item) => {
					// 	if (item.deptId == this.tenderForm.companyId) {
					// 		this.deptlist2 = item.children
					// 		console.log(this.deptlist, 'deptlist===================')
					// 	}
					// })
					// console.log(this.companylist2, 'this.companylist2============================')

				} else {
					this.$message.error(res.msg)
				}
			})

		},
        handlecompanyplan(e) {
			this.deptlist = []
			this.tenderForm.subjectionDeptId = undefined
			this.$nextTick(() => {
				this.companylist.forEach((item) => {
					if (item.deptId == e) {
						this.deptlist = item.children
						// this.tenderForm.companyName = item.title
					}
				})
			})
		},
        // 获取抄送人
        currencygetdata(data) {
            if(data.length>0) {
			    this.cc = data.join(",")
            }
		},
        getList(data) {
            this.fileList = data.arr
        },
        tenderOk() {
         if(this.fileList.length<1) {
            this.$message.warning('请上传招标公告/招标文件!')
            return
        }
		this.$refs.tenderRef.validate((valid) => {
			if (valid) {
				this.$store.commit('LOADING', true)
                this.$store.commit('TIPS', '提交中......')
				bidSave({
					cc: this.cc,
					applyCode: this.code, 
					comId: this.tenderForm.companyId,
					deptId: this.tenderForm.subjectionDeptId,
					salesman: this.tenderForm.salesman,
					deadline: this.tenderForm.deadline, 
					bidFee: this.tenderForm.bidFee,
					deposit: this.tenderForm.deposit,
					send: this.tenderForm.send,
					projectName: this.tenderForm.projectName,
					reason: this.tenderForm.reason
				}).then(res => {
					this.$store.commit('LOADING', false)
                    this.$store.commit('TIPS', '加载中......')
					if(res.code == 200) {
						// 刷新列表
					    this.$emit('ok')
						this.$message.success(res.msg)
					} else {
						this.$message.error(res.msg)
					}
					 
					this.closeView()

					})
				}
			})

        },
		//关闭弹窗
		closeView() {
			this.tenderForm = {
                salesman: '',
                companyId: undefined,//公司id
                // deptId: '',
                subjectionDeptId: undefined,//部门id
                deadline: '',
                bidFee: 0,
                deposit: 0,
                send: undefined,
                reason: '',
				projectName: '',
            }
			this.cc = ''
			this.code = ''
			this.$refs.tenderRef.resetFields()
			this.tenderView = false
		},
        stampDateChange(date) {
			this.tenderForm.deadline = date
		},
    }

}
</script>

<style>

</style>